import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Divider({
  color = "green",
  position = "left",
  textColor = "dark",
  textSize = 5,
  label,
  className,
}) {
  return (
    <div
      className={cleanJoin(
        `divider divider-${color}`,
        `is-size-${textSize}`,
        "pt-5",
        `has-text-${textColor}`,
        `is-${position}`,
        className
      )}
    >
      {label}
    </div>
  );
}

export default Divider;
